import React from 'react';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';

import SilentSaveTextField from 'shared_features/silent_save_textfield';
import SilentSaveSelect from 'shared_features/silent_save_select';
import Avatar from 'shared_features/avatar';

export const selectStyles = {
    control: () => ({
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        alignItems: 'center',
        boxSizing: 'border-box',
    }),
    container: () => ({
        position: 'relative',
    }),
    singleValue: () => ({
        position: 'absolute',
        maxWidth: 217,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        marginLeft: 4,

        color: '#333333',
        fontSize: 14,
        fontWeight: 'regular',
    }),
    input: () => ({
        marginLeft: 4,
        color: '#333333',
        fontSize: 14,
        fontWeight: 'regular',
    }),
    indicatorSeparator: (styles) => ({display:'none'}),
};

export default props => {
   return (
        <li className={styles.athletesContainer}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={()=> props.isSelected ? props.deselectAthlete(props.id) : props.selectAthlete(props.id)}
                className={styles.checkbox} />
            <div className={styles.athletesTable}>
            {props.fields.map(f => {
                switch (f.type) {
                    case 'AVATAR':
                        return <span key={`${props.id}COL${f.type}`} className={styles.avatar}>
                                    <Avatar
                                        isSmall={true}
                                        imageURL={f.value}
                                        uploadEnabled={true}
                                        isUploadingAvatar={props.isUploadingAvatar}
                                        upload={(image) => props.upload(props.id, image)} />
                                </span>;
                    case 'NAME':
                        return <Link to={`/athletes/${props.id}`} key={`${props.id}COL${f.type}`}>
                                    <span className={styles.name}>
                                        {f.value}
                                    </span>
                                </Link>
                    case 'CATEGORY':
                        let value;

                        // If this is a default group, show the team-only option instead
                        if (f.is_default_group) {
                            // Find the team-only option for this team
                            const teamOnly = props.categories.find(c => 
                                c.isTeamOnly && c.teamId === f.team_id
                            );
                            
                            if (teamOnly) {
                                value = teamOnly;
                            } else {
                                // Fallback to exact group match if team-only option not found
                                value = props.categories.find(c => c.value === f.group_id);
                            }
                        } else {
                            // First try to find the exact match
                            value = props.categories.find(c => c.value === f.group_id);
                            
                            // If no direct match, check if this is a "team-only" athlete
                            if (!value && f.group_id === null) {
                                // If group_id is null, check if this athlete has a team assigned
                                const teamOnly = props.categories.find(c => 
                                    c.isTeamOnly && c.teamId === f.team_id
                                );
                                
                                if (teamOnly) {
                                    value = teamOnly;
                                }
                            }
                        }
                        
                        return <span key={`${props.id}COL${f.type}`} className={styles.category}>
                                    <SilentSaveSelect
                                        name="assignees"
                                        styles={selectStyles}
                                        placeholder="None"
                                        value={value}
                                        menuPlacement="auto"
                                        menuPosition="fixed"
                                        menuPortalTarget={document.body}
                                        isClearable={false}
                                        deleteRemoves={false}
                                        isOptionDisabled={(option) => option.isDisabled === true}
                                        onChange={(selectedOption) => {
                                            console.log('Changing athlete category to:', selectedOption);
                                            props.updateAthleteCategory(props.id, selectedOption.value);
                                        }}
                                        options={props.categories}
                                        />
                        </span>
                    case 'MAXABLE_EXERCISE':
                        return <span key={`${props.id}COL${f.exercise_id}`} className={styles.maxableExercise}>
                            <SilentSaveTextField type="number"
                                value={f.value}
                                onComplete={value => props.saveMax(f.max_id, f.exercise_id, props.id, value === '' ? null : parseFloat(value))} />
                        </span>
                    case 'CALCULATED_MAX_EXERCISE':
                        return <span key={`${props.id}COL${f.exercise_id}`} className={styles.maxableExercise}>
                            <input type="number"
                                value={f.value}
                                disabled={true} />
                        </span>
                }})}
            <img src="https://assets.reponestrength.com/edit.png" className={styles.edit} onClick={e => props.editAthlete(props.id)} />
            </div>
        </li>
    );
};
